export const DOMAIN_COUNTRY = {
  cl: 'cl',
  'co.uk': 'gb',
  com: 'es',
  'com.ar': 'ar',
  'com.au': 'au',
  'com.co': 'co',
  'com.mx': 'mx',
  'com.pe': 'pe',
  'com.uy': 'uy',
  de: 'de',
  fr: 'fr',
  it: 'it',
  jp: 'jp',
  net: 'us',
};

export const INTENTMEDIA_CURRENCY = {
  cl: 'CLP',
  'co.uk': 'GBP',
  com: 'EUR',
  'com.ar': 'ARS',
  'com.au': 'AUD',
  'com.co': 'COP',
  'com.mx': 'MXN',
  'com.pe': 'PEN',
  'com.uy': 'UYU',
  de: 'EUR',
  fr: 'EUR',
  it: 'EUR',
  jp: 'JPY',
  net: 'USD',
};


export const DOMAIN_CULTURE = {
  cl: 'es-cl',
  'co.uk': 'en-gb',
  com: 'es-es',
  'com.ar': 'es-ar',
  'com.au': 'en-au',
  'com.co': 'es-co',
  'com.mx': 'es-mx',
  'com.pe': 'es-pe',
  'com.uy': 'es-uy',
  de: 'de-de',
  fr: 'fr-fr',
  it: 'it-it',
  jp: 'ja-jp',
  net: 'en-us',
};

export const HREFLANG = {
  ar: 'es-ar',
  au: 'en-au',
  cl: 'es-cl',
  co: 'es-co',
  de: 'de-de',
  en: 'en-gb',
  es: 'es-es',
  fr: 'fr-fr',
  gb: 'en-gb',
  it: 'it-it',
  jp: 'ja-jp',
  mx: 'es-mx',
  pe: 'es-pe',
  us: 'en-us',
  uy: 'es-uy',
};

export const HOST = {
  ar: 'https://www.hundredrooms.com.ar',
  au: 'https://www.hundredrooms.com.au',
  cl: 'https://www.hundredrooms.cl',
  co: 'https://www.hundredrooms.com.co',
  de: 'https://www.hundredrooms.de',
  es: 'https://www.hundredrooms.com',
  fr: 'https://www.hundredrooms.fr',
  gb: 'https://www.hundredrooms.co.uk',
  it: 'https://www.hundredrooms.it',
  jp: 'https://www.hundredrooms.jp',
  mx: 'https://www.hundredrooms.com.mx',
  pe: 'https://www.hundredrooms.com.pe',
  us: 'https://www.hundredrooms.net',
  uy: 'https://www.hundredrooms.com.uy',
};

export const BLOG_INDEX = {
  ar: 'noindex,nofollow',
  au: 'noindex,nofollow',
  cl: 'noindex,nofollow',
  co: 'noindex,nofollow',
  de: 'index,follow',
  es: 'index,follow',
  fr: 'index,follow',
  gb: 'index,follow',
  it: 'index,follow',
  jp: 'noindex,nofollow',
  mx: 'index,follow',
  pe: 'noindex,nofollow',
  us: 'noindex,nofollow',
  uy: 'noindex,nofollow',
};

export const DOMAIN_POSTBACKS = {
  cl: 'net',
  'co.uk': 'com',
  com: 'com',
  'com.ar': 'net',
  'com.au': 'jp',
  'com.co': 'net',
  'com.mx': 'net',
  'com.pe': 'net',
  'com.uy': 'net',
  de: 'com',
  fr: 'com',
  it: 'com',
  jp: 'jp',
  net: 'net',
};

export const COUNTRY_CONFIG = {
  ar: { analytics: 'UA-49649383-7', hotjar: { active: false, id: '1092348' }, index: false },
  au: { analytics: 'NOT PROVIDED', hotjar: { active: false, id: 'NOT PROVIDED' }, index: false },
  cl: { analytics: 'UA-49649383-6', hotjar: { active: false, id: '1092351' }, index: false },
  co: { analytics: 'UA-49649383-12', hotjar: { active: false, id: 'NOT PROVIDED' }, index: false },
  de: { analytics: 'UA-89117514-1', hotjar: { active: false, id: '421167' }, index: true },
  es: { analytics: 'UA-49649383-1', hotjar: { active: false, id: '220905' }, index: true },
  fr: { analytics: 'UA-88170150-1', hotjar: { active: false, id: '379200' }, index: true },
  gb: { analytics: 'UA-89117410-1', hotjar: { active: false, id: '421164' }, index: true },
  hreflang: [
    { active: true, href: HOST.es, lang: 'es-es' },
    { active: true, href: HOST.mx, lang: 'es-mx' },
    { active: true, href: HOST.it, lang: 'it-it' },
    { active: true, href: HOST.fr, lang: 'fr-fr' },
    { active: true, href: HOST.de, lang: 'de-de' },
    { active: true, href: HOST.gb, lang: 'en-gb' },
    { active: true, href: HOST.us, lang: 'en-us' },
    { active: false, href: HOST.au, lang: 'en-au' },
    { active: true, href: HOST.ar, lang: 'es-ar' },
    { active: true, href: HOST.cl, lang: 'es-cl' },
    { active: true, href: HOST.co, lang: 'es-co' },
    { active: true, href: HOST.pe, lang: 'es-pe' },
    { active: true, href: HOST.uy, lang: 'es-uy' },
    { active: true, href: HOST.jp, lang: 'ja-jp' },
  ],
  it: { analytics: 'UA-88171455-1', hotjar: { active: false, id: '379202' }, index: true },
  jp: { analytics: 'UA-49649383-13', hotjar: { active: false, id: '1092353' }, index: true },
  mx: { analytics: 'UA-84401331-1', hotjar: { active: false, id: '379204' }, index: true },
  pe: { analytics: 'UA-49649383-9', hotjar: { active: false, id: 'NOT PROVIDED' }, index: false },
  us: { analytics: 'UA-49649383-10', hotjar: { active: false, id: 'NOT PROVIDED' }, index: false },
  uy: { analytics: 'UA-49649383-10', hotjar: { active: false, id: 'NOT PROVIDED' }, index: false },
};

export const REDIRECT_LITERALS = {
  de: { accept: 'Ja, auf jeden Fall', decline: 'Nein, danke', domain: 'de', text: 'Deutsche Website anzeigen (EUR)' },
  'en-au': { accept: 'Yes, of course', decline: 'No, thanks', domain: 'com.au', text: 'Go to the english website (AUD)' },
  'en-gb': { accept: 'Yes, of course', decline: 'No, thanks', domain: 'co.uk', text: 'Go to the english website (GBP)' },
  'en-us': { accept: 'Yes, of course', decline: 'No, thanks', domain: 'net', text: 'Go to the english website (USD)' },
  'es-ar': { accept: 'Sí, por supuesto', decline: 'No, gracias', domain: 'com.ar', text: 'Ir a la web en español (ARS)' },
  'es-cl': { accept: 'Sí, por supuesto', decline: 'No, gracias', domain: 'cl', text: 'Ir a la web en español (CLP)' },
  'es-co': { accept: 'Sí, por supuesto', decline: 'No, gracias', domain: 'com.co', text: 'Ir a la web en español (COP)' },
  'es-es': { accept: 'Sí, por supuesto', decline: 'No, gracias', domain: 'com', text: 'Ir a la web en español (EUR)' },
  'es-mx': { accept: 'Sí, por supuesto', decline: 'No, gracias', domain: 'com.mx', text: 'Ir a la web en español (MXN)' },
  'es-pe': { accept: 'Sí, por supuesto', decline: 'No, gracias', domain: 'com.pe', text: 'Ir a la web en español (PEN)' },
  'es-uy': { accept: 'Sí, por supuesto', decline: 'No, gracias', domain: 'com.uy', text: 'Ir a la web en español (UYU)' },
  fr: { accept: 'Oui, bien sûr', decline: 'Non merci', domain: 'fr', text: 'Visiter le site Web en français (EUR)' },
  it: { accept: 'Si, certamente', decline: 'No, grazie', domain: 'it', text: 'Andare alla pagina in italiano (EUR)' },
  ja: { accept: 'はい、もちろん', decline: 'いいえ、けっこうです', domain: 'jp', text: '日本語のウェブサイトへ行く（YEN)' },
};

export const SOCIAL_MEDIA = {
  ar: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsMX/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredrooms' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  au: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsUK/' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  cl: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsMX/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredrooms' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  co: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsMX/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredrooms' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  de: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsDE/' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  es: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/Hundredrooms/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredrooms' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  fr: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsFR/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredroomsFR' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  gb: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsUK/' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  it: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsIT/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredrooms_IT' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  jp: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsUK/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UC3chpcgGsJ19O_SjObPL1GQ' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
  ],
  mx: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsMX/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredrooms' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  us: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsUK/' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
  uy: [
    { icon: 'facebook.svg', name: 'facebook', url: 'https://www.facebook.com/hundredroomsMX/' },
    { icon: 'twitter.svg', name: 'twitter', url: 'https://twitter.com/hundredrooms' },
    { icon: 'youtube.svg', name: 'youtube', url: 'https://www.youtube.com/channel/UCGci1OIsMYnkms4lZ0avstw' },
    { icon: 'instagram.png', name: 'instagram', url: 'https://www.instagram.com/hundredrooms/' },
    { icon: 'pinterest.png', name: 'pinterest', url: 'https://es.pinterest.com/hundredrooms_Es/' },
  ],
};

/**
 * helper to inpect the url's protocol and prepend request protocol if it not exists
 * @param  {object} req -> request
 * @param  {string} uri -> url to inspect
 * @return {string}
 */
export function protocolize(req, uri) {
  const protocol = uri.match('(http|https):\/\/'); // eslint-disable-line
  if (!protocol) return `${req.protocol}:${uri}`;
  return uri;
}

/**
 * Return the first level domain from the actual host
 * @param  {string} host
 * @return {string} com|com.mx|com.ar|...
 */
export function getFirstLevelDomain(host) {
  let domain = host.match('hundredrooms.(.*)?:*');
  [domain] = domain[1].split(':');
  return domain;
}

/**
 * Return culture code for a domain
 * @param  {string} com|com.mx|com.ar|...
 * @return {string} es-es|es-mx|...
 */
export function getCulture(domain) {
  return DOMAIN_CULTURE[domain];
}

/**
 * Return language code for a domain
 * @param  {string} com|com.mx|com.ar|...
 * @return {string} es-es|es-mx|...
 */
export function getLanguage(domain) {
  return DOMAIN_CULTURE[domain].match(/^(..)-..$/)[1];
}

/**
 * Return ISO-3166 country code
 * @param  {string} com|com.mx|com.ar|...
 * @return {string} es|mx|ar|...
 */
export function getCountryIsoCode(domain) {
  return DOMAIN_COUNTRY[domain];
}

/**
 * Return an URL with the correct first level domain
 * @param  {string} url
 * @param  {string} country
 * @return {string} url
 */
export function countryxtualizeURL(url, domain) {
  return url.replace('{DOMAIN}', `.${domain}`);
}

/**
 * Return actual environment
 * @param {string} req.domain
 * @return {string} local|demo|production
 */
export function getDomainEnv(domain) {
  if (domain.startsWith('dev.')) return 'local';
  if (domain.startsWith('demo.')) return 'demo';
  return 'production';
}

export function domainRedirect(originalUrl, domain) {
  function indexOfGroup(match, n) {
    let ix = match.index;
    for (let i = 1; i < n; i++) {
      ix += match[i].length;
    }
    return ix;
  }

  const match = /.hundredrooms\.([a-z.]*)/.exec(originalUrl);
  const startIndex = indexOfGroup(match, 1) + (match[0].length - match[1].length);
  return `${originalUrl.substr(0, startIndex)}${domain}${originalUrl.substr(startIndex + match[1].length)}`;
}

export function getBasePath(country) {
  return HOST[DOMAIN_COUNTRY[country]];
}

export function getRedirect(browserLang, domain) {
  const unicultureLanguages = ['de', 'fr', 'it', 'ja'];
  const [currentLang, currentCulture] = DOMAIN_CULTURE[domain].split('-');
  const [userLang, userCulture] = browserLang.split('-');

  if (unicultureLanguages.includes(userLang)) {
    if (userLang !== currentLang) return userLang;
  } else {
    const isRecognizedLanguage = Object.keys(REDIRECT_LITERALS).some(key => key.split('-')[0] === browserLang.split('-')[0]);
    const isRecognizedCulture = Object.keys(REDIRECT_LITERALS).some(key => key.split('-')[1] === browserLang.split('-')[1]);
    if (!isRecognizedLanguage || !isRecognizedCulture) return null;
    if (userCulture && (userLang !== currentLang || userCulture !== currentCulture)) return browserLang;
  }

  return null;
}
